import React from "react";
import { Link } from "react-router-dom";
import { ConnectWallet } from "../components/ConectButton";
import search from "../assets/img/icons/search.svg";

export default function Header({ page }) {
  const redirectToOfficialSite = () => {
    window.open("https://csxp.netlify.app/", "_blank");
  };

  return (
    <div id="header">
      <div className="left">
        <img className="btn" src={search} alt="Search" />
      </div>
      <div className="right">
        <div className="header-btn" onClick={redirectToOfficialSite}>
          Web Oficial
        </div>
        <ConnectWallet />
      </div>
    </div>
  );
}
